import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { errorDescriptionsMap, toUrl } from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';
import { EnvironmentType } from 'src/environments/environmentTypes';

@Component({
  selector: 'app-doctors-next-register-connect-cportal',
  templateUrl: './doctors-next-register-connect-cportal.component.html',
  styleUrls: [
    './doctors-next-register-connect-cportal.component.css',
    '../style/index.css',
  ],
})
export class DoctorsNextRegisterConnectCportalComponent
  extends BaseLoginComponent
  implements OnInit {
  async init(): Promise<void> {
    setTimeout(() => {
      this.setEmail(
        sessionStorage.getItem(sessionStorageKey.doctorsNextCpIntegration.email)
      );
    }, 0);
  }

  protected get errorDescripitionsMap(): typeof errorDescriptionsMap {
    return {
      'Wrong email or password.': '正しいパスワードを入力してください',
      'Missing credentials': errorDescriptionsMap['Missing credentials'],
      "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.":
        errorDescriptionsMap[
        "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it."
        ],
      "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it.":
        errorDescriptionsMap[
        "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it."
        ],
    };
  }

  getCportalPasswordResetUrl() {
    const config = this.getCportalConfig();
    if (!config) return undefined;
    const clientId = config?.clientId || '';
    return toUrl({
      clientId,
      path: 'forgot-password',
    });
  }

  getCportalConfig() {
    for (const [clientId, app] of Object.entries(environment.apps)) {
      if (
        DoctorsNextRegisterConnectCportalComponent.isCportalConfig(
          app,
          this.clientId
        )
      ) {
        return app;
      }
    }
    return undefined;
  }

  // environmentsの設定から、このconnect設定に関連するclientIdかどうかを判定する
  static isCportalConfig(
    app: EnvironmentType['apps'][0],
    targetClientId: string
  ) {
    const config = app['cportal-connect-config-for-collaboportal'];
    if (!config) return false;
    if (config.dnextClientId !== targetClientId) return false;

    return true;
  }

  gotoRegisterPage() {
    this.router.navigate(['/register'], {
      queryParamsHandling: 'preserve',
      fragment: null,
    });
  }
}
